<template>
  <div>
    <pageHeader :dropdownData="transactionsColumns"
                :props="{ headerName: 'header', value: 'fieldName' }"
                :headerIcon="'money bill alternate outline'"
                :headerText="$t('transactions')"
                :haveFilterInput="true"
                @filterString="filterStringEventListener"
                @columnName="columnNameEventListener"
                :columnsNumber="['five wide column', 'two wide column', 'nine wide column']"
                @startSearchingProcess="startSearchingProcessEventListener">
    </pageHeader>

    <div class="" style="padding-top: 30px;">
      <abstractTable
        :columns="transactionsColumns"
        style="padding-top: 0px"
        :useData="false"
        :classes="'ui tablet very compact center aligned celled table'"
        :dataPerPage="25" :paginationEnable="true"
        :paginationFirstPageButtonText="$t('first')"
        :paginationLastPageButtonText="$t('last')"
        :paginationNextButtonText="$t('next')"
        :paginationPervButtonText="$t('previous')"
        :indexRoute="'transactions'"
        :apiObjectName="'transactions'"
        :methodFormatter="computedTransactions"
        :filters="filterStringBuilder"
        @endSearchingProcess="endSearchingProcessEventListener"
        :startSearchingFlag="startSearching"
      >
        <template slot="table-column">
          <th class="no-print" width="20%"> {{ $t('actions') }} </th>
        </template>
        <template slot="table-row-after" slot-scope="props">
          <td class="no-print">
            <div class="ui blue tiny button"
                 style="background-color: #092442"
                 @click="showModal('update-transaction', props.row)">
              Reqest Change
            </div>
          </td>
        </template>
      </abstractTable>
    </div>

    <div class="ui large longer modal" id="update-transaction" style="margin-top: 20px !important;">
      <div class="header">{{ $t('addTransaction') }}</div>
      <div class="scrolling content">
        <div class="ui form" id="update-transaction-form">

          <div class="required field">
            <label for="transactionAmount">{{ $t('transactionAmount') }}</label>
            <div class="ui input left icon">
              <i class="money icon"></i>
              <input type="number"
                     :placeholder="$t('transactionAmount')"
                     v-model="choosenTransaction.amount"
                     name="updateTransactionAmount">
            </div>
          </div>

          <div class="required field">
            <label for="description">{{ $t('updateReason') }}</label>
            <textarea :placeholder="$t('updateReason')"
                      v-model="choosenTransaction.reason"
                      name="updateReason">
            </textarea>
          </div>

          <div class="ui blue right floated button"
               style="background-color: #092442"
               @click="createUpdateRequest('update-transaction')">
            {{ $t('createUpdateRequest') }}
          </div>

          <div class="ui right floated button"
               @click="hideModal('update-transaction')">
            {{ $t('discard') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      transactions: [],
      transactionParams: {
        amount: null,
        description: null,
        paid_at: null
      },
      choosenTransaction: {},
      filterString: '',
      columnName: 'all',
      startSearching: false
    }
  },
  computed: {
    filterStringBuilder () {
      return '&id=' + this.filterString
    },
    transactionsColumns () {
      return [
        { header: this.$t('id'), fieldName: 'id', show: true, filterable: true },
        { header: this.$t('amount'), fieldName: 'amount', show: true, filterable: false, width: '10%' },
        { header: this.$t('description'), fieldName: 'description', show: true, filterable: false },
        { header: this.$t('paidAt'), fieldName: 'paid_at', show: true, filterable: false, width: '20%' },
        { header: this.$t('transactionFor'), fieldName: 'transaction_for', show: true, filterable: false, width: '8%' }
      ]
    },
    currentDate () {
      return window.moment().format('LLLL')
    }
  },
  methods: {
    filterStringEventListener (event) {
      this.filterString = event.data
    },
    columnNameEventListener (event) {
      this.columnName = event.data
    },
    startSearchingProcessEventListener (event) {
      this.startSearching = true
    },
    endSearchingProcessEventListener (event) {
      this.startSearching = false
    },
    computedTransactions (transactions) {
      let formlatedTransactions = []

      window._.each(transactions, transaction => {
        formlatedTransactions.push({
          id: transaction.id,
          amount: this.formatPrice(transaction.amount),
          description: transaction.description || '-',
          paid_at: window.moment(transaction.paid_at).format('DD/MM/YYYY hh:mm a'),
          transaction_for: transaction.transactable_type
        })
      })

      return formlatedTransactions
    },
    initUpdateTransactionUI () {
      this.$nextTick(() => {
        $('#update-transaction-form').form({
          inline: true,
          on: 'blur',
          fields: {
            updateTransactionAmount: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter the transaction amount.'
                },
                {
                  type: 'number',
                  prompt: 'Please, Enter a valid number.'
                }
              ]
            },
            updateReason: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Type a reason for changing your transaction.'
                }
              ]
            }
          }
        })
      })
    },
    showModal (modalId, currentTransaction = null) {
      $(`#${modalId}`).modal('show').modal('refresh')
      if (currentTransaction) {
        this.choosenTransaction = window._.cloneDeep(currentTransaction)
        this.choosenTransaction.reason = ''
        this.initUpdateTransactionUI()
      }
    },
    hideModal (modalId) {
      this.transactionParams = {
        amount: null,
        description: null,
        paid_at: null
      }

      $(`#${modalId}`).modal('hide')
    },
    createUpdateRequest (modalId) {
      if ($('#update-transaction-form').form('is valid')) {
        this.$http.post(`transactions/${this.choosenTransaction.id}/update/request`, {
          transaction: {
            amount: this.choosenTransaction.amount,
            reason: this.choosenTransaction.reason
          },
          clinic_id: this.getFromLocalStorage('clinicId')
        }).then(response => {
          this.hideModal(modalId)
        })
      }
    }
  },
  beforeDestroy () {
    $('#update-transaction').remove()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/transactions/Transactions.vue